<template>
  <div class="space-y-4 p-4">
    <viewTitle
      :title="`业务管理 / 基础数据管理 / 自助取样点管理/ ${recordId == 0 ? '新建' : '修改'}取样点`"
      :showReturn="true"
    />
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="所属基地" required>
        {{ baseInfo.com_name }}
      </el-form-item>
      <el-form-item label="取样点名称" prop="name">
        <el-input
          class="w-96"
          v-model="form.name"
          placeholder="请输入取样点名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="车辆业务类型" prop="car_business_list">
        <template v-if="form.car_business_list.length > 0">
          <c-table
            class="w-5/12"
            :isIndex="false"
            :data="form.car_business_list"
            :columns="columns"
            :showPagination="false"
          >
            <template slot="car_business_name" slot-scope="{ row }">
              <div v-for="item in row.car_business" :key="item.id">
                {{ item.name }}
              </div>
            </template>
            <template slot="action" slot-scope="{ row, $index }">
              <div class="space-x-2">
                <c-link @click="onEditCar(row, $index)" label="修改"></c-link>
                <c-link @click="onDelCar($index)" label="删除"></c-link>
              </div>
            </template>
          </c-table>
        </template>
        <c-link @click="onAddCar" label="添加"></c-link>
      </el-form-item>
      <el-form-item label="加抽比例%" prop="pumping_ratio">
        <el-input-number
          placeholder="请输入加抽比例，如输入10，即10%加抽比例"
          class="inputNumber w-96"
          :step="1"
          step-strictly
          v-model="form.pumping_ratio"
          controls-position="right"
          :min="0"
          :max="100"
          :controls="false"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="加抽装卸点" prop="warehouse_id">
        <tableSelector
          :multiple="false"
          title="选择加抽装卸点"
          v-model="form.warehouse_id"
          :rows.sync="form.warehouse"
          url="/api/queue/admin/query_warehouse"
          :columns="warehouseColumns"
        >
          <template slot="content">
            <div>
              <div v-for="item in form.warehouse" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="取样点管理员" prop="user_list">
        <tableSelector
          title="选择取样点人员"
          v-model="form.user_list"
          :rows.sync="form.user_list_data"
          :columns="userColumns"
          :params="user_list_params"
          :http-request="userLoad"
          @close="onUserClose"
        >
          <div class="mb-4" slot="search">
            <el-input class="w-60" clearable v-model="user_list_params.keyword" placeholder="搜索账号、手机号和联系人"></el-input>
            <span style="margin-left: 10px;">角色：</span>
            <el-select
              multiple
              v-model="user_list_params.role_id"
              clearable
              placeholder="请选择角色"
            >
              <el-option
                v-for="item in baseRoleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div slot="content">
            <span v-if="form.user_list_data.length > 0">{{
              form.user_list_data | formatUser
            }}</span>
          </div>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择人员</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="取样点指引" prop="guide_id">
        <tableSelector
          :multiple="false"
          title="选择取样点指引"
          v-model="form.guide_id"
          :rows.sync="form.guide"
          url="/api/queue/admin/query_guide"
          :params="guide_params"
          :columns="guideColumns"
        >
          <template slot="content">
            <div>
              <div v-for="item in form.guide" :key="item.id">
                {{ item.name }}
              </div>
            </div>
          </template>
          <el-link type="primary" class="align-top" :underline="false"
            >请选择</el-link
          >
        </tableSelector>
      </el-form-item>
      <el-form-item label="备注" prop="note">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 6 }"
          placeholder="请输入备注"
          v-model="form.note"
          class="w-96"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <el-button @click="onSave" type="primary">{{ this.recordId == 0 ? '新建' : '保存' }}</el-button>
    <el-dialog title="添加车辆业务类型" :close-on-click-modal="false" :visible.sync="visible" width="40%">
      <el-form
        ref="carForm"
        :model="carForm"
        label-width="120px"
        :rules="carFormRules"
      >
        <el-form-item label="车辆业务类型" prop="car_business_id">
          <tableSelector
            :multiple="false"
            title="选择车辆业务类型"
            v-model="carForm.car_business_id"
            :rows.sync="carForm.car_business"
            url="/api/queue/admin/query_business"
            :params="{
              is_parent: 1,
              state: 1,
              keyword: businessKeyword
            }"
            :columns="carBusinessColumns"
          >
            <div class="mb-4" slot="search">
              <span>关键字：</span><el-input class="w-60" v-model="businessKeyword" placeholder="输入关键字搜索"></el-input>
            </div>
            <template slot="content">
              <div>
                <div v-for="item in carForm.car_business" :key="item.id">
                  {{ item.name }}
                </div>
              </div>
            </template>
            <el-link type="primary" :underline="false">选择业务类型</el-link>
          </tableSelector>
        </el-form-item>
        <el-form-item label="取样比例" prop="sampling_ratio">
          <el-input-number
            class="inputNumber w-24"
            v-model="carForm.sampling_ratio"
            controls-position="right"
            :min="1"
            :max="100"
            :controls="false"
          ></el-input-number
          ><span class="ml-2">%</span>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onAddCarCancel">取 消</el-button>
        <el-button type="primary" @click="onCarConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableSelector from "@/components/tableSelector/index.vue";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form: {
        car_business_list: [],
        user_list_data: []
      },
      businessKeyword: "",
      user_list_params: {
        keyword: "",
        role_id: []
      },
      guide_params: { type: 1 },
      carForm: {
        car_business_id: [],
        car_business: [],
        sampling_ratio: 100
      },
      carBusinessColumns: [
        { label: "车辆代码", prop: "code" },
        { label: "车辆预约业务类型", prop: "name" }
      ],
      rules: {
        name: [
          { required: true, message: "请输入取样点名称", trigger: "blur" }
        ],
        pumping_ratio: [
          { required: true, message: "请输入加抽比例", trigger: "blur" }
        ],
        warehouse_id: [
          { required: true, message: "请选择加抽装卸点", trigger: "change", type: "array" }
        ],
        guide_id: [
          { required: true, message: "请选择取样点指引", trigger: "change", type: "array" }
        ],
        user_list: [
          { required: true, message: "请选择取样点人员", trigger: "change", type: "array" }
        ],
        car_business_list: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ]
      },
      carFormRules: {
        car_business_id: [
          {
            required: true,
            message: "请选择车辆业务类型",
            trigger: "change",
            type: "array"
          }
        ],
        sampling_ratio: [
          { required: true, message: "请输入取样比例", trigger: "blur" }
        ]
      },
      columns: [
        {
          label: "车辆业务类型",
          prop: "car_business_name"
        },
        {
          label: "取样比例(%)",
          prop: "sampling_ratio",
          width: 120
        },
        {
          label: "操作",
          prop: "action",
          width: 100
        }
      ],
      warehouseColumns: [
        { label: "装卸点名称", prop: "name" }
      ],
      guideColumns: [{ label: "指引名称", prop: "name" }],
      userColumns: [
        { label: "联系人", prop: "contact" },
        { label: "账号", prop: "account" },
        { label: "角色", prop: "role_name" }
      ],
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "baseRole"]),
    recordId() {
      return this.$route.params.id;
    },
    baseRoleList() {
      return this.baseRole.filter(e => {
        const insider = [
          "admin",
          "sampler",
          "sample_receiver",
          "stevedore",
          "gate_guard"
        ].includes(e.code);
        const isCustom = e.code.indexOf("custom-") === 0;
        return insider || isCustom;
      });
    }
  },
  components: {
    tableSelector
  },
  filters: {
    formatUser(list) {
      return list.map(e => e.contact).join("；");
    }
  },
  created () {
    if (this.recordId != 0) {
      this.getDetail();
    }
  },
  methods: {
    onSave() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            const {
              car_business_list,
              warehouse_id,
              warehouse,
              user_list_data,
              guide_id,
              guide,
              ...params
            } = this.form;
            
            const formData = {
              ...params,
              car_business_list: car_business_list.map(item => {
                const { car_business, ...other } = item;
                return {
                  ...other,
                  car_business_id: String(other.car_business_id)
                };
              }),
              warehouse_id: String(warehouse_id),
              guide_id: String(guide_id),
              id: this.recordId == 0 ? "" : this.recordId
            };
            await this.$common.http({
              url:
                this.recordId == 0
                  ? "/api/queue/admin/create_sampling_point"
                  : "/api/queue/admin/update_sampling_point",
              data: formData
            });
          } catch (error) {
            console.log(error);
          }
          this.$router.back();
        }
      });
    },
    onAddCar() {
      this.visible = true;
    },
    onAddCarCancel() {
      this.visible = false;
      this.carForm = {
        car_business_id: [],
        car_business: [],
        sampling_ratio: 100
      };
    },
    onCarConfirm() {
      this.$refs.carForm.validate(valid => {
        if (valid) {
          if (!this.carForm.index) {
            this.form.car_business_list.push({ ...this.carForm });
          } else {
            this.$set(this.form.car_business_list, this.carForm.index, {...this.carForm })
          }
          this.onAddCarCancel();
          console.log(this.form.car_business_list);
        }
      });
    },
    onDelCar(index) {
      this.form.car_business_list.splice(index, 1);
    },
    onEditCar(row, index) {
      console.log(row);
      this.carForm = { ...row, index: `${index}` };
      this.visible = true;
    },
    async userLoad(params) {
      const defaultRoleId = this.baseRoleList.map((e) => e.id).join(',');
      const dataObj = await this.$common.http({
        url: "/api/contact/search",
        data: {
          ...params,
          role_id: (params.role_id && params.role_id.length > 0) ? params.role_id.join(",") : defaultRoleId,
          limit: params.page_size,
          offset: (params.page - 1) * params.page_size,
          type: 2
        }
      });
      return {
        data: dataObj.data.data.items,
        total: dataObj.data.data.total
      };
    },
    onUserClose() {
      this.user_list_params.keyword = '';
      this.user_list_params.role_id = [];
    },
    async getDetail() {
      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/detail_sampling_point",
          data: {
            id: this.recordId
          }
        });
        console.log(dataObj);
        const { name, car_business_list, pumping_ratio, warehouse_id, warehouse_name, users, guide_id, guide_name, note } = dataObj.data.data;
        let formData = {
          name,
          car_business_list: car_business_list.map((item) => {
            return {
              sampling_ratio: item.sampling_ratio,
              car_business_id: [item.car_business_id],
              car_business: [
                {
                  id: item.car_business_id,
                  name: item.car_business_name
                }
              ]
            }
          }),
          pumping_ratio,
          user_list: users.map((item) => item.id),
          user_list_data: users.map((item) => {
            return {
              id: item.id,
              contact: item.name
            }
          }),
          guide_id: [guide_id],
          guide: [
            {
              id: guide_id,
              name: guide_name
            }
          ],
          warehouse_id: [warehouse_id],
          warehouse: [
            {
              id: warehouse_id,
              name: warehouse_name
            }
          ],
          note
        }
        this.form = formData;
      } catch (error) {
        
      }
    }
  }
};
</script>

<style lang="less" scoped>
.inputNumber {
  /deep/ .el-input__inner {
    text-align: left !important;
  }
}
/deep/ .el-input__validateIcon {
  display: none;
}
</style>
